<template>
  <div>
    <v-dialog
      :value="value"
      width="1300"
      @input="$emit('input',$event)"
    >
      <v-card
        v-if="whsItem"
        light
        style="font-size: 14px;"
      >
        <v-toolbar
          dark
          dense
          color="blue"
        >
          <v-toolbar-title>
            阿里巴巴新增地址範例
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              @click.native="$emit('input',false)"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <div style="position: relative;">
            <img
              src="./images/1688-addr-exmp.png"
              width="1250"
              style="pointer-events: none;"
            >
            <span style="position: absolute;width: 300px;left:440px;top:340px;">
              {{ whsItem.province }}
              {{ whsItem.city }}
              {{ whsItem.district }}
              {{ whsItem.street }}
            </span>
            <span style="position: absolute;width: 300px;left:440px;top:377px;">
              {{ whsItem.desc }}{{ whsItem.formatAddr.uidNum }}
            </span>
            <span style="position: absolute;width: 300px;left:440px;top:428px;">
              {{ whsItem.formatAddr.postcode }}
            </span>
            <span style="position: absolute;width: 300px;left:440px;top:304px;">
              {{ whsItem.formatAddr.name }}
            </span>
            <span style="position: absolute;width: 300px;left:440px;top:465px;">
              {{ whsItem.formatAddr.phone }}
            </span>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    whsItem: Object,
    value: Boolean,
  },
  data () {
    return {
      switch1: true,
    }
  }
}
</script>
